<template>
  <div>
    <b-overlay :show="isLoading" rounded="sm" spinner-variant="primary" opacity="0.6">
      <!------------------
            HEADER
    -------------------->
      <div class="bg-white p-3 pl-4 page-header" ref="pageHeader" style="padding-bottom: 0">
        <div class="row d-flex align-items-center" style="max-width: 1000px">
          <div class="col">
            <div>
              <h4>
                <b-icon class="me-2" icon="file-earmark"></b-icon>

                {{ $route.params.id ? 'Auftrag' + (editMode ? ' bearbeiten' : '') : 'Auftrag erfassen' }}
              </h4>
            </div>
          </div>
          <div class="col-auto">
            <div class="form-inline">
              <!---------------------------------
            HEADER ACTION BUTTONS
        ---------------------------------->
              <b-button
                v-if="!isNewRecord() && !editMode && ($root.$user.isPlaner || $root.$user.isAdmin)"
                class="mr-2"
                variant="light"
                @click="editMode = !editMode"
              >
                <b-icon icon="lock" variant="dark" class="" style="padding-top: 1px"></b-icon>
              </b-button>
              <b-button v-if="!isNewRecord() && editMode" class="mr-2" variant="light" @click="editMode = !editMode">
                <b-icon icon="unlock" variant="dark" class="" style="padding-top: 1px"></b-icon>
              </b-button>
              <b-button
                variant="secondary"
                class="text-white"
                @click="saveRecordAndReturn"
                v-show="editMode || isNewRecord()"
                :disabled="!recordFormChanged"
              >
                <b-icon icon="check2" variant="white" class="mr-1" style="padding-top: 1px"></b-icon>
                Auftrag speichern
              </b-button>
              <!--
              <b-button
                variant="light"
                class=""
                @click="$router.push('/orders/' + $route.params.id + '/addendums')"
                v-show="!editMode"
                title="Nachträge verwalten"
              >
                <b-icon icon="card-list" title="Nachträge" />
              </b-button>-->

              <!--
              <b-button
                class="ml-2"
                variant="light"
                style="padding-top: 3px; padding-bottom: 2px; padding-left: 9px; padding-right: 9px"
                @click="$router.push('/orders')"
              >
              -->
              <!--
              <b-button
                class="ml-2"
                variant="light"
                style="padding-top: 3px; padding-bottom: 2px; padding-left: 9px; padding-right: 9px"
                @click="comingFromInvoices ? $router.go(-1) : $router.push('/orders')"
              >
                <b-icon icon="x" variant="dark" class="" style="padding-top: 1px; height: 26px; width: 26px"></b-icon>
              </b-button>
              -->
              <b-button
                class="ml-2"
                variant="light"
                style="padding-top: 3px; padding-bottom: 2px; padding-left: 9px; padding-right: 9px"
                @click="$router.go(-1)"
              >
                <b-icon icon="x" variant="dark" class="" style="padding-top: 1px; height: 26px; width: 26px"></b-icon>
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <!-----------------------------
    MAIN CANVAS
    ------------------------------>
      <div class="main-canvas pb-0">
        <b-form
          ref="recordForm"
          id="recordForm"
          enctype="multipart/form-data"
          accept-charset="utf-8"
          autocomplete="off"
        >
          <input
            type="file"
            class="d-none"
            accept=".png, .jpg, .jpeg"
            placeholder="Datei wählen..."
            drop-placeholder="Drop file here..."
            @change="uploadFile"
            ref="fileInput"
          />
          <div class="row" style="max-width: 1000px">
            <div class="col">
              <h5>Vergabeeinheit</h5>
              <hr class="mt-0" />
            </div>
          </div>
          <div class="row ml-2" style="max-width: 977px">
            <div class="col">
              <b-form-group>
                <label><small>Vergabeeinheit</small></label>
                <AkLookupField
                  icon="three-dots"
                  :data="allocationUnits"
                  :text.sync="record.text"
                  :selectedItemId.sync="record.VeDbId"
                  placeholder="Vergabeeinheit"
                  required
                  :disabled="!editMode"
                  title="Verfügbare Vergabeeinheiten (mit Budget)"
                  @change="
                    checkAvailableBudget();
                    recordFormChanged = true;
                  "
                />
              </b-form-group>
            </div>
          </div>
          <div class="row ml-2" style="max-width: 977px">
            <div class="col-6">
              <b-form-group>
                <label>
                  <small>
                    <b-form-radio
                      v-model="record.veSection"
                      name="some-radios"
                      value="A"
                      size="sm"
                      :disabled="!editMode"
                      @change="onFormFieldKeyUp"
                    >
                      Vergabeempfehlung
                    </b-form-radio>
                  </small>
                </label>
                <b-form-input
                  :disabled="record.veSection == 'B' || !editMode"
                  :readonly="record.veSection == 'B'"
                  v-model="record.VergabeEmpfehlung"
                  placeholder="Vergabeempfehlung"
                  :class="{ readonly: editMode }"
                  @keyup="onFormFieldKeyUp"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-6">
              <b-form-group>
                <label>
                  <small>Datum der Vergabeempfehlung</small>
                </label>
                <b-form-input
                  :disabled="record.veSection == 'B' || !editMode"
                  :readonly="record.veSection == 'B'"
                  type="date"
                  v-model="record.VergabeEmpfehlungDatum"
                  placeholder="Datum der Vergabeempfehlung"
                  :class="{ readonly: editMode }"
                  @keyup="onFormFieldKeyUp"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row ml-2" style="max-width: 977px">
            <div class="col-6">
              <b-form-group>
                <label>
                  <small>
                    <b-form-radio
                      v-model="record.veSection"
                      name="some-radios"
                      value="B"
                      size="sm"
                      :disabled="!editMode"
                      @change="onFormFieldKeyUp"
                    >
                      Bestellnummer
                    </b-form-radio>
                  </small>
                </label>
                <b-form-input
                  placeholder="Bestellnummer"
                  v-model="record.OrderNumber"
                  :disabled="record.veSection == 'A' || !editMode"
                  :readonly="record.veSection == 'A'"
                  :class="{ readonly: editMode }"
                  @keyup="onFormFieldKeyUp"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-6">
              <b-form-group>
                <label>
                  <small>Auftragsdatum</small>
                </label>
                <b-form-input
                  type="date"
                  v-model="record.OrderDate"
                  placeholder="Auftragsdatum"
                  :disabled="record.veSection == 'A' || !editMode"
                  :readonly="record.veSection == 'A'"
                  :class="{ readonly: editMode }"
                  @keyup="onFormFieldKeyUp"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row" style="max-width: 1000px">
            <div class="col" style="max-width: 1000px">
              <h5 class="mt-3">Auftragnehmer</h5>
              <hr class="mt-0" />
            </div>
          </div>
          <div class="row ml-2" style="max-width: 977px">
            <div class="col-6">
              <b-form-group>
                <label>
                  <small>Firma</small>
                </label>
                <b-form-input
                  :disabled="!editMode"
                  required
                  placeholder="Firma"
                  v-model="record.SupplierText"
                  @keyup="onFormFieldKeyUp"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-6">
              <b-form-group>
                <label>
                  <small>Projektleiter (optional)</small>
                </label>
                <b-form-input
                  :disabled="!editMode"
                  v-model="record.ProjectLead"
                  placeholder="Projektleiter"
                  @keyup="onFormFieldKeyUp"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row ml-2" style="max-width: 977px">
            <div class="col-6">
              <b-form-group>
                <label>
                  <small>Adresse</small>
                </label>
                <b-form-textarea
                  v-model="record.SupplierAddress"
                  rows="2"
                  max-rows="2"
                  placeholder="Adresse"
                  :disabled="!editMode"
                  @keyup="onFormFieldKeyUp"
                />
              </b-form-group>
            </div>
          </div>
          <div class="row" style="max-width: 1000px">
            <div class="col" style="max-width: 1000px">
              <h5 class="mt-3">Auftrag</h5>
              <hr class="mt-0" />
            </div>
          </div>
          <div class="row ml-2" style="max-width: 977px">
            <div class="col-3">
              <AkCurrencyField
                v-model="record.Amount"
                label="Bewertung"
                label-class="text-small"
                input-class="text-right"
                input-ref="AmountField"
                @update="
                  checkAvailableBudget();
                  recalcMwst('netto');
                "
                @keyup="recordFormChanged = true"
                :disabled="!editMode"
                :required="true"
                form="recordForm"
                id="AmountField"
                min="0.01"
              />

              <transition name="fade">
                <div v-if="ntrExceeded" class="text-danger mt-1 mb-2" style="overflow: visible; white-space: nowrap">
                  <small>
                    <b-icon icon="exclamation-triangle" class="mr-1" />
                    Zielvergabe der Vergabeeinheit ({{
                      formatCurrency(parseFloat(this.budgetSaldo) * (1 - parseFloat(this.budgetNTR / 100)))
                    }}) wurde überschritten.
                  </small>
                </div>
              </transition>
              <!--</b-form-group> -->
            </div>
            <div class="col-2">
              <b-form-group>
                <label>
                  <small>MwSt. Satz</small>
                </label>
                <b-input-group prepend="%" :class="{ readonly: !editMode }">
                  <b-form-input
                    type="number"
                    step="0.1"
                    min="0"
                    pattern="^\d+(?:\.\d{1,2})?$"
                    v-model="record.AmountMwSt"
                    @update="recalcMwst('mwst')"
                    lazy
                    :disabled="!editMode"
                    @keyup="onFormFieldKeyUp"
                    required
                  />
                </b-input-group>
              </b-form-group>
            </div>
            <div class="col-2">
              <b-form-group>
                <label>
                  <small>MwSt.</small>
                </label>

                <AkCurrencyField v-model="record.AmountMwStValue" :disabled="!editMode" readonly />
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group>
                <label>
                  <small>Brutto</small>
                </label>

                <AkCurrencyField
                  v-model="record.AmountBrutto"
                  @update="recalcMwst('brutto')"
                  :disabled="!editMode"
                  min="0.01"
                  @keyup="onFormFieldKeyUp"
                />
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group>
                <label>
                  <small>Enthaltener Nachlass</small>
                </label>

                <b-form-input
                  type="text"
                  placeholder="€ oder %"
                  step="0.01"
                  min="0.01"
                  v-model="record.AmountNachlass"
                  :disabled="!editMode"
                  @keyup="onFormFieldKeyUp"
                />
              </b-form-group>
            </div>
          </div>
          <div class="row ml-2" style="max-width: 977px">
            <div class="col">
              <AkLinkField
                label="Link zum Dokument"
                label-class="text-small"
                icon="box-arrow-up-right"
                v-model="record.DocumentLink"
                placeholder="Link zum Dokument"
                :disabled="!editMode"
                @keyup="onFormFieldKeyUp"
              ></AkLinkField>
            </div>
          </div>
          <div class="row ml-2" style="max-width: 977px">
            <div class="col-3">
              <b-form-group v-slot="{ ariaDescribedby }" class="text-nowrap">
                <label>
                  <small>Pauschaliert</small>
                </label>
                <b-form-radio-group
                  style="margin-top: 6px"
                  v-model="record.PauschaliertOption"
                  :options="yesNoPartlyOptions"
                  :aria-describedby="ariaDescribedby"
                  name="pausch-options"
                  :disabled="!editMode"
                  @change="onFormFieldKeyUp"
                ></b-form-radio-group>
              </b-form-group>
            </div>
            <div class="col-3">
              <b-form-group v-slot="{ ariaDescribedby }">
                <label>
                  <small>Zahlungsplan</small>
                </label>
                <b-form-radio-group
                  style="margin-top: 6px"
                  v-model="record.ZahlungsPlanOption"
                  :options="yesNoOptions"
                  :aria-describedby="ariaDescribedby"
                  name="zp-options"
                  :disabled="!editMode"
                  @change="onFormFieldKeyUp"
                ></b-form-radio-group>
              </b-form-group>
            </div>
            <div class="col align-self-end" style="padding-bottom: 19px">
              <label v-if="record.ZahlungsPlanOption && editMode"><small></small></label>
              <b-button
                v-if="record.ZahlungsPlanOption && editMode && record.ZahlungsPlanFile == null"
                block
                variant="secondary"
                size="sm"
                @click="openFileDialog('ZahlungsPlanFile')"
                style="max-width: 217px"
              >
                Zahlungsplan hochladen
              </b-button>
              <span v-if="record.ZahlungsPlanOption && record.ZahlungsPlanFile">
                {{ record.ZahlungsPlanFileName }}
                <b-button size="sm" variant="outline-primary" class="ml-3">
                  <b-icon icon="download" @click="downloadFile('ZahlungsPlanFile')" />
                </b-button>
                <b-button
                  size="sm"
                  variant="outline-primary"
                  class="ml-2"
                  @click="removeFile('ZahlungsPlanFile')"
                  v-if="editMode"
                >
                  <b-icon icon="trash" />
                </b-button>
              </span>
            </div>
          </div>
          <div class="row ml-2" style="max-width: 977px">
            <div class="col-3">
              <b-form-group>
                <label>
                  <small>Zahlungsziel</small>
                </label>
                <b-form-input v-model="record.Zahlungsziel" :disabled="!editMode" @keyup="onFormFieldKeyUp" />
              </b-form-group>
            </div>
            <div class="col-3">
              <b-form-group v-slot="{ ariaDescribedby }">
                <label>
                  <small>Skonto</small>
                </label>
                <b-form-radio-group
                  style="margin-top: 6px"
                  v-model="record.SkontoOption"
                  :options="yesNoOptions"
                  :aria-describedby="ariaDescribedby"
                  name="skonto-options"
                  :disabled="!editMode"
                  @change="onFormFieldKeyUp"
                ></b-form-radio-group>
              </b-form-group>
            </div>
            <div class="col-3">
              <b-form-group v-if="record.SkontoOption">
                <label>
                  <small>Skonto %</small>
                </label>
                <b-input-group prepend="%" :class="{ readonly: !editMode }">
                  <b-form-input
                    type="number"
                    step="0.1"
                    min="0.1"
                    max="99.9"
                    v-model="record.Skonto"
                    :disabled="!editMode"
                    :required="record.SkontoOption && editMode"
                    @keyup="onFormFieldKeyUp"
                  />
                </b-input-group>
              </b-form-group>
            </div>
            <div class="col-3">
              <b-form-group v-if="record.SkontoOption">
                <label>
                  <small>Skontofrist (Tage)</small>
                </label>
                <b-form-input
                  v-model="record.SkontoFrist"
                  :disabled="!editMode"
                  :required="record.SkontoOption && editMode"
                  @keyup="onFormFieldKeyUp"
                  type="number"
                  min="1"
                  max="50"
                />
              </b-form-group>
            </div>
          </div>
          <div class="row ml-2" style="max-width: 1000px"></div>

          <div class="row" style="max-width: 1000px">
            <div class="col" style="max-width: 1000px">
              <h5 class="mt-3">Grundlagen (optional)</h5>
              <hr class="mt-0" />
            </div>
          </div>
          <div class="row ml-2" style="max-width: 977px">
            <div class="col-3">
              <b-form-group>
                <label>
                  <small>Datum letztes Angebot</small>
                </label>
                <b-form-input
                  type="date"
                  v-model="record.LastQuoteDate"
                  :disabled="!editMode"
                  @keyup="onFormFieldKeyUp"
                />
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group>
                <label>
                  <small>Kommentar</small>
                </label>
                <b-form-input
                  v-model="record.LastQuoteComment"
                  :disabled="!editMode"
                  @keyup="onFormFieldKeyUp"
                  maxlength="100"
                />
              </b-form-group>
            </div>
          </div>
          <div class="row ml-2" style="max-width: 977px">
            <div class="col-3">
              <b-form-group>
                <label>
                  <small>Datum letztes Verhandlungsgespräch</small>
                </label>
                <b-form-input
                  type="date"
                  v-model="record.LastNegoDate"
                  :disabled="!editMode"
                  @keyup="onFormFieldKeyUp"
                />
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group>
                <label>
                  <small>Kommentar</small>
                </label>
                <b-form-input
                  v-model="record.LastNegoComment"
                  :disabled="!editMode"
                  @keyup="onFormFieldKeyUp"
                  maxlength="100"
                />
              </b-form-group>
            </div>
          </div>

          <div class="row ml-2" style="max-width: 977px">
            <div class="col">
              <b-form-group>
                <label>
                  <small>Ausführungsfrist(en)</small>
                </label>
                <b-form-textarea
                  rows="2"
                  max-rows="2"
                  placeholder="Ausführungsfrist(en)"
                  v-model="record.Ausfuehrungsfristen"
                  :disabled="!editMode"
                  @keyup="onFormFieldKeyUp"
                  maxlength="150"
                />
              </b-form-group>
            </div>
          </div>

          <div class="row ml-2" style="max-width: 977px">
            <div class="col-3">
              <b-form-group>
                <label>
                  <small>Gewährleistungsdauer</small>
                </label>
                <b-form-input
                  type="text"
                  v-model="record.GewaehrJahre"
                  :disabled="!editMode"
                  @keyup="onFormFieldKeyUp"
                />
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group>
                <label>
                  <small>Kommentar</small>
                </label>
                <b-form-input
                  v-model="record.GewaehrComment"
                  :disabled="!editMode"
                  @keyup="onFormFieldKeyUp"
                  maxlength="100"
                />
              </b-form-group>
            </div>
          </div>
          <div class="row ml-2" style="max-width: 977px">
            <div class="col-3">
              <b-form-group>
                <label><small>Freistellungsbescheinigung</small></label>
                <b-form-checkbox
                  style="margin-top: 7px"
                  v-model="record.FreistellungCheck"
                  :value="true"
                  :unchecked-value="false"
                  :disabled="!editMode"
                  @change="onFormFieldKeyUp"
                >
                  Freistellungsbescheinigung
                </b-form-checkbox>
              </b-form-group>
            </div>
            <div class="col-6 align-self-end" style="padding-bottom: 13px" v-if="record.FreistellungCheck">
              <label v-if="record.FreistellungCheck && editMode"><small>&nbsp;</small></label>
              <b-button
                v-if="record.FreistellungCheck && editMode && record.FreistellungFile == null"
                block
                variant="secondary"
                size="sm"
                @click="openFileDialog('FreistellungFile')"
                style="max-width: 217px"
              >
                Bescheinigung hochladen
              </b-button>
              <span v-if="record.FreistellungCheck && record.FreistellungFile">
                {{ record.FreistellungFileName }}
                <b-button size="sm" variant="outline-primary" class="ml-3">
                  <b-icon icon="download" @click="downloadFile('FreistellungFile')" />
                </b-button>
                <b-button
                  size="sm"
                  variant="outline-primary"
                  class="ml-2"
                  @click="removeFile('FreistellungFile')"
                  v-if="editMode"
                >
                  <b-icon icon="trash" />
                </b-button>
              </span>
            </div>
            <div class="col-3" v-if="record.FreistellungCheck">
              <label><small>Gültig bis</small></label>
              <b-form-input
                :style="[
                  new Date(record.FreistellungDatum) < new Date() ? { color: 'red', 'border-color': 'red' } : false
                ]"
                type="date"
                v-model="record.FreistellungDatum"
                :disabled="!editMode"
                :required="record.FreistellungCheck && editMode"
                @keyup="onFormFieldKeyUp"
              />
            </div>
          </div>
          <div class="row" style="max-width: 1000px">
            <div class="col" style="max-width: 1000px">
              <h5 class="mt-3">Umlagen und Abzüge (optional)</h5>
              <hr class="mt-0" />
            </div>
          </div>
          <div class="row ml-2" style="max-width: 977px">
            <div class="col">
              <b-form-group>
                <label>
                  <small>
                    Beschreibung der Umlagen
                    <b-icon
                      style="vertical-align: -0.25em; margin-left: 3px"
                      icon="question-circle"
                      title="Entgeltminderung mit Vorsteuerkürzung = EGMin mVK"
                      class="text-muted"
                    ></b-icon>
                  </small>
                </label>
                <b-form-input
                  v-model="record.UmlageComment"
                  :disabled="!editMode"
                  @keyup="onFormFieldKeyUp"
                  maxlength="50"
                />
              </b-form-group>
            </div>
            <div class="col-3">
              <b-form-group>
                <label>
                  <small>% von Abrechnungssumme</small>
                </label>
                <b-input-group prepend="%" :class="{ readonly: !editMode }">
                  <b-form-input
                    type="number"
                    step="0.1"
                    v-model="record.UmlagePercent"
                    :disabled="!editMode"
                    @keyup="onFormFieldKeyUp"
                  />
                </b-input-group>
              </b-form-group>
            </div>
            <div class="col-3">
              <b-form-group>
                <label>
                  <small>zzgl./alternativ Betrag</small>
                </label>

                <AkCurrencyField v-model="record.Umlage" :disabled="!editMode" @keyup="onFormFieldKeyUp" />
              </b-form-group>
            </div>
          </div>
          <div class="row ml-2" style="max-width: 977px">
            <div class="col">
              <b-form-group>
                <label>
                  <small>
                    Beschreibung der Abzüge
                    <b-icon
                      style="vertical-align: -0.25em; margin-left: 3px"
                      icon="question-circle"
                      title="Entgeltminderung ohne Vorsteuerkürzung = EGMin oVK"
                      class="text-muted"
                    ></b-icon>
                  </small>
                </label>
                <b-form-input
                  v-model="record.AbzuegeComment"
                  :disabled="!editMode"
                  @keyup="onFormFieldKeyUp"
                  maxlength="50"
                />
              </b-form-group>
            </div>
            <div class="col-3">
              <b-form-group>
                <label>
                  <small>% von Abrechnungssumme</small>
                </label>
                <b-input-group prepend="%" :class="{ readonly: !editMode }">
                  <b-form-input
                    type="text"
                    v-model="record.AbzuegePercent"
                    :disabled="!editMode"
                    @keyup="onFormFieldKeyUp"
                  />
                </b-input-group>
              </b-form-group>
            </div>
            <div class="col-3">
              <b-form-group>
                <label>
                  <small>zzgl./alternativ Betrag</small>
                </label>

                <AkCurrencyField v-model="record.Abzuege" :disabled="!editMode" @keyup="onFormFieldKeyUp" />
              </b-form-group>
            </div>
          </div>
          <div class="row ml-2" style="max-width: 977px">
            <div class="col-3">
              <b-form-group>
                <label><small>Vertragsstrafe</small></label>
                <b-form-checkbox
                  class="mb-2"
                  style="margin-top: 7px"
                  v-model="record.VStrafeCheck"
                  :value="true"
                  :unchecked-value="false"
                  :disabled="!editMode"
                  @change="onFormFieldKeyUp"
                >
                  Pönale vereinbart
                </b-form-checkbox>
              </b-form-group>
            </div>
            <div class="col-3" v-if="record.VStrafeCheck">
              <b-form-group>
                <label><small>Prozent</small></label>
                <b-input-group prepend="%" :class="{ readonly: !editMode }">
                  <b-form-input
                    type="number"
                    step="0.1"
                    v-model="record.VStrafeProzent"
                    :disabled="!editMode"
                    :required="record.VStrafeCheck"
                    @keyup="onFormFieldKeyUp"
                  />
                </b-input-group>
              </b-form-group>
            </div>
            <div class="col" v-if="record.VStrafeCheck">
              <b-form-group>
                <label><small>Beschreibung der Vertragsstrafenregelung</small></label>
                <b-form-input
                  v-model="record.VStrafeComment"
                  :disabled="!editMode"
                  :required="record.VStrafeCheck"
                  @keyup="onFormFieldKeyUp"
                />
              </b-form-group>
            </div>
          </div>

          <div class="row" style="max-width: 1000px">
            <div class="col" style="max-width: 1000px">
              <h5 class="mt-3">Sicherheiten (optional)</h5>
              <hr class="mt-0" />
            </div>
          </div>
          <div class="row ml-2 align-items-start" style="max-width: 977px">
            <div class="col col-3">
              <b-form-group class="mb-0">
                <label><small>Vorauszahlungsbürgschaft</small></label>
                <b-form-checkbox
                  v-model="record.VZahlCheck"
                  :value="true"
                  :unchecked-value="false"
                  :disabled="!editMode"
                  @change="onFormFieldKeyUp"
                >
                  Vorauszahlungsbürgschaft vereinbart
                </b-form-checkbox>
              </b-form-group>
            </div>
            <div class="col col-3">
              <b-form-group v-if="record.VZahlCheck">
                <label><small>Betrag</small></label>

                <AkCurrencyField
                  step="0.01"
                  v-model="record.VZahlAmount"
                  :disabled="!editMode"
                  :required="record.VZahlCheck && editMode"
                  @keyup="onFormFieldKeyUp"
                />
              </b-form-group>
              <b-form-group>
                <b-button
                  block
                  variant="secondary"
                  size="sm"
                  @click="openFileDialog('VZahlFile')"
                  v-if="record.VZahlCheck && editMode && record.VZahlFile == null"
                  style="max-width: 217px"
                >
                  Bürgschaft hochladen
                </b-button>
                <div v-if="record.VZahlCheck && record.VZahlFile" style="white-space: nowrap; overflow-y: hidden">
                  <span style="float: right">
                    <b-button size="sm" variant="outline-primary">
                      <b-icon icon="download" @click="downloadFile('VZahlFile')" />
                    </b-button>
                    <b-button
                      size="sm"
                      variant="outline-primary"
                      class="ml-2"
                      @click="removeFile('VZahlFile')"
                      v-if="editMode"
                    >
                      <b-icon icon="trash" />
                    </b-button>
                  </span>
                  <span style="display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
                    <small>{{ record.VZahlFileName }}</small>
                  </span>
                </div>
              </b-form-group>
            </div>
            <div class="col col-6">
              <b-form-group v-if="record.VZahlCheck">
                <label><small>Beschreibung der Anrechnungsmodalitäten</small></label>
                <b-form-textarea
                  v-model="record.VZahlComment"
                  :disabled="!editMode"
                  :required="record.VZahlCheck && editMode"
                  @keyup="onFormFieldKeyUp"
                  style="height: 80px"
                  maxlength="150"
                />
              </b-form-group>
            </div>
          </div>
          <!---
          <div class="row ml-2 align-items-end" style="max-width: 977px">
            <div class="col-3">
              <b-form-group class="mb-0">
                <label><small>Vorauszahlungsbürgschaft</small></label>
                <b-form-checkbox
                  v-model="record.VZahlCheck"
                  :value="true"
                  :unchecked-value="false"
                  :disabled="!editMode"
                  @change="onFormFieldKeyUp"
                >
                  Vorauszahlungsbürgschaft vereinbart
                </b-form-checkbox>
              </b-form-group>
            </div>
            <div class="col-9">
              <b-form-group>
                <b-button
                  block
                  variant="secondary"
                  size="sm"
                  @click="openFileDialog('VZahlFile')"
                  v-if="record.VZahlCheck && editMode && record.VZahlFile == null"
                  style="max-width: 217px"
                >
                  Bürgschaft hochladen
                </b-button>
                <span v-if="record.VZahlCheck && record.VZahlFile">
                  {{ record.VZahlFileName }}
                  <b-button size="sm" variant="outline-primary" class="ml-3">
                    <b-icon icon="download" @click="downloadFile('VZahlFile')" />
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    class="ml-2"
                    @click="removeFile('VZahlFile')"
                    v-if="editMode"
                  >
                    <b-icon icon="trash" />
                  </b-button>
                  <b-spinner label="Spinning" small class="ml-2" variant="light" v-if="isUploading"></b-spinner>
                </span>
              </b-form-group>
            </div>
          </div>
          <div class="row ml-2 mt-2" style="max-width: 977px" v-if="record.VZahlCheck">

            <div class="col-3">
              <b-form-group>
                <label><small>Betrag</small></label>
                <b-input-group prepend="€" :class="{ readonly: !editMode }">
                  <b-form-input
                    type="number"
                    step="0.01"
                    v-model="record.VZahlAmount"
                    :disabled="!editMode"
                    :required="record.VZahlCheck && editMode"
                    @keyup="onFormFieldKeyUp"
                  />
                </b-input-group>
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group>
                <label><small>Beschreibung der Anrechnungsmodalitäten</small></label>
                <b-form-input
                  v-model="record.VZahlComment"
                  :disabled="!editMode"
                  :required="record.VZahlCheck && editMode"
                  @keyup="onFormFieldKeyUp"
                />
              </b-form-group>
            </div>
          </div> -->
          <div class="row ml-2 mt-2" style="max-width: 977px">
            <div class="col-3">
              <b-form-group class="mb-0">
                <label><small>Vertragserfüllungssicherheit</small></label>
                <b-form-checkbox
                  v-model="record.VErfuellCheck"
                  :value="true"
                  :unchecked-value="false"
                  :disabled="!editMode"
                  @change="onFormFieldKeyUp"
                >
                  Vertragserfüllungssicherheit vereinbart
                </b-form-checkbox>
              </b-form-group>
            </div>
            <div class="col-3" v-if="record.VErfuellCheck">
              <b-form-group class="mb-0">
                <label><small>Art</small></label>
                <b-form-select
                  v-model="record.VErfuellArt"
                  :disabled="!editMode"
                  :required="record.VErfuellCheck && editMode"
                  @change="
                    onFormFieldKeyUp();
                    onVErfuellArtChange();
                  "
                >
                  <b-form-select-option :value="null" disabled>Bitte wählen</b-form-select-option>
                  <b-form-select-option value="0">Bürgschaft</b-form-select-option>
                  <b-form-select-option value="1">Einbehalt</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-3">
              <b-form-group v-if="record.VErfuellCheck">
                <label><small>Prozent</small></label>
                <b-input-group prepend="%" :class="{ readonly: !editMode }">
                  <b-form-input
                    type="number"
                    step="0.1"
                    v-model="record.VErfuellProzent"
                    :disabled="!editMode"
                    :required="record.VErfuellCheck && editMode"
                    @keyup="onFormFieldKeyUp"
                  />
                </b-input-group>
              </b-form-group>
            </div>
            <div class="col-3">
              <b-form-group v-if="record.VErfuellCheck">
                <label><small>von</small></label>
                <b-form-select
                  v-model="record.VErfuellVon"
                  :disabled="!editMode || record.VErfuellArt == 0"
                  :required="record.VErfuellCheck && editMode"
                  @change="onFormFieldKeyUp"
                >
                  <b-form-select-option :value="null" disabled>Bitte wählen</b-form-select-option>
                  <b-form-select-option value="0">Auftragssumme</b-form-select-option>
                  <b-form-select-option value="1">Abrechnungssumme</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
          </div>
          <div class="row ml-2" style="max-width: 977px" v-if="record.VErfuellCheck">
            <div class="col-3">&nbsp;</div>
            <div class="col-9">
              <b-form-group>
                <b-button
                  block
                  variant="secondary"
                  size="sm"
                  @click="openFileDialog('VErfuellFile')"
                  v-if="
                    record.VErfuellCheck && editMode && record.VErfuellFile == null && parseInt(record.VErfuellArt) == 0
                  "
                  style="max-width: 217px"
                >
                  Bürgschaft hochladen
                </b-button>
                <span v-if="record.VErfuellCheck && record.VErfuellFile && parseInt(record.VErfuellArt) == 0">
                  <small>{{ record.VErfuellFileName }}</small>
                  <b-button size="sm" variant="outline-primary" class="ml-3">
                    <b-icon icon="download" @click="downloadFile('VErfuellFile')" />
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    class="ml-2"
                    @click="removeFile('VErfuellFile')"
                    v-if="editMode"
                  >
                    <b-icon icon="trash" />
                  </b-button>
                </span>
              </b-form-group>
            </div>
          </div>
          <div class="row ml-2 mt-2" style="max-width: 977px">
            <div class="col-3">
              <b-form-group class="mb-0">
                <label><small>Mängelhaftungssicherheit</small></label>
                <b-form-checkbox
                  v-model="record.MSicherCheck"
                  :value="true"
                  :unchecked-value="false"
                  :disabled="!editMode"
                  @change="
                    onFormFieldKeyUp();
                    setDefaultMHPercent();
                  "
                >
                  Mängelhaftungssicherheit vereinbart
                </b-form-checkbox>
              </b-form-group>
            </div>
            <div class="col-3" v-if="record.MSicherCheck">
              <b-form-group class="mb-0">
                <label><small>Art</small></label>
                <b-form-select
                  v-model="record.MSicherArt"
                  :disabled="!editMode"
                  :required="record.MSicherCheck && editMode"
                  @change="onFormFieldKeyUp"
                >
                  <b-form-select-option :value="null" disabled>Bitte wählen</b-form-select-option>
                  <b-form-select-option value="0">Bürgschaft</b-form-select-option>
                  <b-form-select-option value="1">Einbehalt</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-3" v-if="record.MSicherCheck">
              <b-form-group>
                <label><small>Prozent</small></label>
                <b-input-group prepend="%" :class="{ readonly: !editMode }">
                  <b-form-input
                    type="number"
                    step="0.1"
                    min="0.1"
                    max="99.9"
                    v-model="record.MSicherProzent"
                    :disabled="!editMode"
                    pattern="[0-9]+([,][0-9]{1,2})?"
                    :required="record.MSicherCheck && editMode"
                    @keyup="onFormFieldKeyUp"
                  />
                </b-input-group>
              </b-form-group>
            </div>
            <div class="col-3" v-if="record.MSicherCheck">
              <b-form-group>
                <label><small>von</small></label>
                <b-form-select
                  v-model="record.MSicherVon"
                  :disabled="!editMode"
                  :required="record.MSicherCheck && editMode"
                  @change="onFormFieldKeyUp"
                >
                  <b-form-select-option value="0">Netto-Abrechnungssumme</b-form-select-option>
                  <b-form-select-option value="1">Brutto-Abrechnungssumme</b-form-select-option>
                  <!--
                  <b-form-select-option value="2">Netto-Auftragssumme</b-form-select-option>
                  <b-form-select-option value="3">Brutto-Auftragssumme</b-form-select-option>
                  -->
                </b-form-select>
              </b-form-group>
            </div>
          </div>
          <div class="row ml-2 mt-2 mb-4" style="max-width: 977px">
            <div class="col-3"></div>
            <div class="col-9" v-if="record.MSicherCheck">
              <b-form-group>
                <b-button
                  block
                  variant="secondary"
                  size="sm"
                  @click="openFileDialog('MSicherFile')"
                  v-if="
                    record.MSicherCheck && editMode && record.MSicherFile == null && parseInt(record.MSicherArt) == 0
                  "
                  style="max-width: 217px"
                >
                  Bürgschaft hochladen
                </b-button>
                <span v-if="record.MSicherCheck && record.MSicherFile">
                  <small>{{ record.MSicherFileName }}</small>
                  <b-button size="sm" variant="outline-primary" class="ml-3">
                    <b-icon icon="download" @click="downloadFile('MSicherFile')" />
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    class="ml-2"
                    @click="removeFile('MSicherFile')"
                    v-if="editMode"
                  >
                    <b-icon icon="trash" />
                  </b-button>
                </span>
              </b-form-group>
            </div>
            <div class="col-3" v-if="record.MSicherCheck"></div>
          </div>
        </b-form>
        <br />
        <br />
      </div>
    </b-overlay>

    <!-- main-canvas -->
  </div>
</template>

<script>
import AppState from '@/store/App.js';
import AllocationUnitsService from '@/service/AllocationUnitsService';
import AkLookupField from '@/components/AkLookupFieldNoPre';
import AkCurrencyField from '@/components/AkCurrencyField';
import OrdersService from '@/service/OrdersService';
import SettingsStore from '@/store/Settings';
import AkLinkField from '@/components/AkLinkField';

export default {
  components: {
    AkLookupField,
    AkCurrencyField,
    AkLinkField
  },
  data() {
    return {
      comingFromInvoices: null,
      recordFormChanged: false,
      allocationUnits: null,
      isLoading: true,
      editMode: false,
      record: {},
      yesNoOptions: [
        { text: 'Ja', value: true },
        { text: 'Nein', value: false }
      ],
      yesNoPartlyOptions: [
        { text: 'Ja', value: true },
        { text: 'teilweise', value: 'teilw' },
        { text: 'Nein', value: false }
      ],
      initUploadField: '',
      OrdersService,
      ntrExceeded: false,
      budgetSaldo: null,
      budgetNTR: null,
      MSicherProzent: null
      /*
      budgetExhausted: false,
      budgetVe: 0*/
    };
  },
  methods: {
    onVErfuellArtChange() {
      if (this.record.VErfuellArt == 0) this.record.VErfuellVon = 0;
    },
    onFormFieldKeyUp(key) {
      if (
        key &&
        (key.which == 9 ||
          key.which == 13 ||
          key.which == 16 ||
          key.which == 27 ||
          key.which == 32 ||
          key.which == 35 ||
          key.which == 36 ||
          key.which == 37 ||
          key.which == 39)
      )
        return;

      this.recordFormChanged = true;
    },
    removeFile(field) {
      this.$bvModal
        .msgBoxConfirm(
          'Soll die Datei "' +
            this.record[field + 'Name'] +
            '"wirklich entfernt werden? Das Löschen der Datei kann nicht rückgängig gemacht werden.',
          {
            title: 'Dokument löschen',
            okTitle: 'Bestätigen',
            cancelTitle: 'Abbrechen',
            okVariant: 'danger',

            centered: true
          }
        )
        .then(confirmed => {
          if (confirmed) {
            OrdersService.deleteFile(this.record.DbId, this.record[field], field)
              .then(() => {
                //this.editMode = false;
                this.record[field] = null;
                this.$showSuccess(this, 'Datei löschen', 'Datei erfolgreich aktualisiert.');
              })
              .catch(err => {
                if (err.response) this.$showError(this, err.response.data.error);
                else this.$showError(this, err.toString());
              });
          }
        });
    },
    async saveRecordAndReturn(evt) {
      if (this.record.veSection == 'A') {
        if (this.record.VergabeEmpfehlungDatum == null || this.record.VergabeEmpfehlungDatum == '') {
          this.record.VergabeEmpfehlungDatum = this.$utils.currentBrowserDate();
        }
      }
      if (this.record.veSection == 'B') {
        if (this.record.OrderDate == null || this.record.OrderDate == '') {
          this.record.OrderDate = this.$utils.currentBrowserDate();
        }
      }
      await this.$forceUpdate();

      const input = document.querySelector('#AmountField');
      input.setCustomValidity('');
      if (!this.$refs.recordForm.checkValidity()) {
        evt.preventDefault();
        return this.$refs.recordForm.reportValidity();
      }
      if (this.$router.currentRoute.params && this.$router.currentRoute.params.id) {
        // update the current record
        this.isLoading = true;

        OrdersService.update(this.record)
          .then(() => {
            this.editMode = false;
            this.$showSuccess(this, 'Auftrag speichern', 'Auftrag erfolgreich aktualisiert.');
          })
          .catch(err => {
            if (err.response.status) {
              if (err.response.status == 512) {
                // 512 = Auftrag uznterschreitet Summe abrechnung
                if (err.response) this.$showError(this, err.response.data.error);
                else this.$showError(this, err.toString());
              } else if (err.response.status == 510) {
                // 510 = VE Budget überschritten
                this.checkAvailableBudget();
                this.$showError(this, 'Das Budget der Vergabeeinheit wurde überschritten.');
              } else {
                if (err.response) this.$showError(this, err.response.data.error);
                else this.$showError(this, err.toString());
              }
            } else {
              if (err.response) this.$showError(this, err.response.data.error);
              else this.$showError(this, err.toString());
            }
          })
          .finally(() => {
            this.isLoading = false;
            //this.$router.go(-1);
          });
      } else {
        // insert a new record
        this.isLoading = true;
        OrdersService.create(this.record)
          .then(() => {
            this.$showSuccess(this, 'Auftrag speichern', 'Auftrag erfolgreich erstellt.');
            this.$router.go(-1);
          })
          .catch(err => {
            if (err.response.status) {
              if (err.response.status == 512) {
                // 512 = Auftrag uznterschreitet Summe abrechnung
                if (err.response) this.$showError(this, err.response.data.error);
                else this.$showError(this, err.toString());
              } else if (err.response.status == 510) {
                // 510 = VE Budget überschritten
                //this.checkAvailableBudget();
                this.$showError(this, 'Das Budget der Vergabeeinheit wurde überschritten.');
              } else {
                if (err.response) this.$showError(this, err.response.data.error);
                else this.$showError(this, err.toString());
              }
            } else {
              if (err.response) this.$showError(this, err.response.data.error);
              else this.$showError(this, err.toString());
            }
          })
          .finally(() => {
            this.isLoading = false;

            //this.editMode = false;
          });
      }
    },
    formatCurrency(number) {
      return this.$utils.numberToCurrency(number, SettingsStore.settings['Centbetraege']);
    },
    formatDate(val) {
      if (val.length > 2) {
        if (val.substr(2, 1) !== '.') {
          val = val.substr(0, 2) + '.' + val.substr(2);
        }
      }
      if (val.length > 5) {
        if (val.substr(5, 1) !== '.') {
          val = val.substr(0, 5) + '.' + val.substr(5);
        }
      }
      if (val.length > 10) val = val.substr(0, 10);
      return val;
    },
    recalcMwst(whatChanged) {
      if (whatChanged == 'netto') {
        this.record.AmountMwStValue = (parseFloat(this.record.Amount) * parseFloat(this.record.AmountMwSt)) / 100;
        this.record.AmountBrutto = parseFloat(this.record.Amount) + parseFloat(this.record.AmountMwStValue);
      } else if (whatChanged == 'brutto') {
        //this.record.Amount = parseFloat(this.record.AmountBrutto) / (1 + (parseFloat(this.record.AmountMwSt)/100));
        this.record.Amount = (parseFloat(this.record.AmountBrutto) * 100) / (100 + parseFloat(this.record.AmountMwSt)); // * 100/119
        this.record.AmountMwStValue = (this.record.Amount * this.record.AmountMwSt) / 100;
      } else if (whatChanged == 'mwst') {
        this.record.AmountMwStValue = (this.record.Amount * this.record.AmountMwSt) / 100;
        this.record.AmountBrutto = parseFloat(this.record.Amount) + parseFloat(this.record.AmountMwStValue);
      }
    },
    /*
    formatDecimals(number) {
      if (!number) {
        if (SettingsStore.settings['Centbetraege']) return '0,00';
        else return '0';
      }
      if (SettingsStore.settings['Centbetraege']) {
        return parseFloat(number).toFixed(2);
      } else return parseInt(number);
    },*/
    isNewRecord() {
      return this.$router.currentRoute.params && typeof this.$router.currentRoute.params.id === 'undefined';
    },
    openFileDialog(field) {
      if (!this.record.DbId) {
        return this.$bvModal.msgBoxOk(
          'Bitte speichern Sie den Auftrag zunächst, bevor Dateien hochgeladen werden können.',
          {
            title: 'Datei hochladen',
            okVariant: 'danger',
            headerTextVariant: 'danger',
            centered: true
          }
        );
      }

      this.$refs.fileInput.value = null;
      this.initUploadField = field;

      this.$refs.fileInput.click();
    },
    async uploadFile(e) {
      this.isLoading = true;
      await this.$forceUpdate();

      OrdersService.uploadFile(this.$router.currentRoute.params.id, e.target.files[0], this.initUploadField)
        .then(fileInfo => {
          this.record[this.initUploadField] = fileInfo.fileId;
          this.record[this.initUploadField + 'Name'] = fileInfo.fileName;

          this.$showSuccess(this, 'Datei hochladen', 'Datei erfolgreich aktualisiert.');
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    downloadFile(field) {
      OrdersService.download(this.$router.currentRoute.params.id, field).catch(async err => {
        if (err.response) this.$showError(this, await err.response.data.text());
        else this.$showError(this, err.toString());
      });
    },
    checkAvailableBudget() {
      if (!this.record.VeDbId) return;
      AllocationUnitsService.checkBudget(this.record.VeDbId, this.record.Amount)
        .then(checkResult => {
          this.budgetSaldo = checkResult.BudgetSaldo;
          if (checkResult.NTR != null) {
            this.budgetNTR = parseFloat(checkResult.NTR);
          } else this.budgetNTR = SettingsStore.settings['Nachtragsprozent'];
          const budgetNTRValue = parseFloat(this.budgetSaldo) * (1 - parseFloat(this.budgetNTR / 100));
          this.ntrExceeded = parseFloat(this.record.Amount) > budgetNTRValue;
          if (this.record.Amount > checkResult.BudgetSaldo) {
            //this.budgetExhausted = false;
            //const input = document.querySelector('#AmountField');
            //input.setCustomValidity('VE Budget (' + this.formatCurrency(checkResult.BudgetSaldo) + ') überschritten.');
            //return input.reportValidity();
          }
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        });
    },
    setDefaultMHPercent() {
      if (this.record.MSicherCheck && this.record.MSicherCheck == true) {
        if (!this.record.MSicherProzent) this.record.MSicherProzent = SettingsStore.settings['MHProzent'];
      } else {
        this.record.MSicherProzent = null;
      }
    }
  },

  deactivated() {
    window.removeEventListener('keydown', this.goBackOnEsc); // Succeeds
  },
  async activated() {
    window.addEventListener('keydown', this.goBackOnEsc);
    this.editMode = false;
    this.ntrExceeded = false;
    await this.$forceUpdate(); // prevent the "auftrag speichern" button to shorty appear and then disappear due to editMode = false
    if (this.$router.currentRoute.params && this.$router.currentRoute.params.id) {
      // --------------------------------
      // load existing order
      // --------------------------------
      OrdersService.getById(this.$router.currentRoute.params.id)
        .then(order => {
          this.record = { ...this.record, ...order };

          //this.record.Amount = this.formatDecimals(this.record.Amount);
          //this.record.AmountNachlass = this.formatDecimals(this.record.AmountNachlass);
          //this.record.Umlage = this.formatDecimals(this.record.Umlage);
          //this.record.Abzuege = this.formatDecimals(this.record.Abzuege);
          //if (this.record.VZahlAmount) this.record.VZahlAmount = this.formatDecimals(this.record.VZahlAmount);

          this.record.AbnahmeDatum = this.$utils.SQLDateToBrowserDate(this.record.AbnahmeDatum);
          this.record.LastNegoDate = this.$utils.SQLDateToBrowserDate(this.record.LastNegoDate);
          this.record.LastQuoteDate = this.$utils.SQLDateToBrowserDate(this.record.LastQuoteDate);
          this.record.FreistellungDatum = this.$utils.SQLDateToBrowserDate(this.record.FreistellungDatum);
          this.record.VergabeEmpfehlungDatum = this.$utils.SQLDateToBrowserDate(this.record.VergabeEmpfehlungDatum);
          this.record.OrderDate = this.$utils.SQLDateToBrowserDate(this.record.OrderDate);

          switch (this.record.PauschaliertOption) {
            case 'true':
              this.record.PauschaliertOption = true;
              break;
            case 'false':
              this.record.PauschaliertOption = false;

              break;
            case 'teilw':
              break;
            default:
              this.record.PauschaliertOption = false;
          }
          //this.record.PauschaliertOption = this.record.PauschaliertOption === 'true' ? true : false;
          this.record.SkontoOption = this.record.SkontoOption === 'true' ? true : false;
          this.record.ZahlungsPlanOption = this.record.ZahlungsPlanOption === 'true' ? true : false;
          this.record.FreistellungCheck = this.record.FreistellungCheck === 'true' ? true : false;
          this.record.VStrafeCheck = this.record.VStrafeCheck === 'true' ? true : false;
          this.record.VZahlCheck = this.record.VZahlCheck === 'true' ? true : false;
          this.record.VErfuellCheck = this.record.VErfuellCheck === 'true' ? true : false;
          this.record.MSicherCheck = this.record.MSicherCheck === 'true' ? true : false;
          this.record.MSicherProzent = this.$utils.numberWithMaxFrictions(this.record.MSicherProzent, 1);
          this.record.VErfuellProzent = this.$utils.numberWithMaxFrictions(this.record.VErfuellProzent, 1);

          this.record.text = this.record.Ordinal + ' ' + this.record.DisplayName;

          if (this.record.MSicherVon == null) this.record.MSicherVon = SettingsStore.settings['MHSicherheit'];

          this.recalcMwst('netto');
          this.checkAvailableBudget();
          this.$nextTick(() => {
            AllocationUnitsService.getAllocationUnitsWOOrdersIncl(this.record.VeDbId) //getAllocationUnitsWOOrders      getAllocationUnitsSimple
              .then(allocationUnits => {
                this.allocationUnits = allocationUnits.map(x => {
                  x.text =
                    x.Ordinal + ' ' + x.DisplayName + ' (' + this.formatCurrency(parseFloat(x.BudgetSaldo)) + ')';
                  return x;
                });
              })
              .finally(() => {
                AppState.isLoading = false;
              });
          });
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        })
        .finally(() => {
          this.$nextTick(() => {
            this.recalcMwst('netto');
            AppState.isLoading = false;
            this.isLoading = false;
            this.recordFormChanged = false;
          });
        });
    } else {
      // --------------------------------
      // show empty form for creating new order
      // --------------------------------
      this.record = {
        Amount: null,
        AmountBrutto: null,
        AmountNachlass: null,
        VErfuellArt: null,
        VErfuellVon: null,
        AmountMwStValue: null,
        ZahlungsPlanOption: false,
        SkontoOption: false,
        PauschaliertOption: false,
        VStrafeCheck: false,
        FreistellungCheck: false,
        VZahlCheck: false,
        VErfuellCheck: false,
        maengelhaftungCheck: false,
        veSection: 'A',
        MSicherVon: SettingsStore.settings['MHSicherheit'],
        MSicherProzent: null,
        MSicherArt: null,
        AmountMwSt: SettingsStore.settings['Mehrwertsteuersatz']
      };

      this.isLoading = false;
      this.editMode = true;
      this.budgetSaldo = null;
      this.recordFormChanged = false;
      this.$nextTick(() => {
        AllocationUnitsService.getAllocationUnitsWOOrders() //getAllocationUnitsWOOrders      getAllocationUnitsSimple
          .then(allocationUnits => {
            this.allocationUnits = allocationUnits.map(x => {
              x.text = x.Ordinal + ' ' + x.DisplayName + ' (' + this.formatCurrency(parseFloat(x.BudgetSaldo)) + ')';
              return x;
            });
          })
          .finally(() => {
            AppState.isLoading = false;
          });
      });
    }
  }
};
</script>

<style scoped>
.page-header {
  border-bottom: 1px solid #dee2e6;
}
.main-canvas {
  height: calc(100vh - 500px);
  overflow-y: auto;
}
/*
input:read-only {
  background-color: #fbfbfb !important;
  color: #999;
}*/
#form-table {
  width: 100%;
}
#form-table td {
  padding: 0 10px 10px 0;
}
/* we will explain what these classes do next! */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
